import { getStateWithOnlyOneLevel } from '../../utils/StateSelectorHelper';

function getNotificationMessageState(state) {
  return getStateWithOnlyOneLevel(state, 'notificationsMessageReducer');
}

export const getNotificationsMessageUnreadSelectors = (state) =>
  getNotificationMessageState(state).get('notificationsUnread');

export const getNotificationsMessageSeenSelectors = (state) =>
  getNotificationMessageState(state).get('notificationsSeen');

export const loadNotificationSelectors = (state) =>
  getNotificationMessageState(state).get('loadNotification');
